import type { ProListPageControllerFormValues } from '@application/components';
import type { ProSearchData } from '@application/utils';
import type { ProfessionalTypeEnum } from '@gql/graphql';
import type {
  CardItemProData,
  FiltersWithModalData,
  ModalData,
  PaginationData,
} from '@presentation/components';
import type { MouseEventHandler } from 'react';
import type { MapProps } from './components/Map/types';

export interface ProListPageMapSelectedItemData extends CardItemProData {}

export interface ProListPageMapData {
  mobileShown: boolean;
  onMobileShownToggle?: MouseEventHandler;
  selectedPro?: ProListPageMapSelectedItemData;
  selectedLoading?: boolean;
  modal: ModalData;
  loading?: boolean;
  lastSavedValues: ProListPageControllerFormValues;
  onRefreshClick?: MouseEventHandler;
  props: MapProps;
  canRefresh?: boolean;
}

export interface ProListPageData {
  map: ProListPageMapData;
  items: CardItemProData[];
  unclaimedItems: CardItemProData[];

  pagination: PaginationData;
  loading?: boolean;
  headerTitle: string;

  proSearch: ProSearchData;
  type: ProfessionalTypeEnum;

  onResetClick?: MouseEventHandler;

  filtersModal: FiltersWithModalData;
}

export interface ProListPageProps extends ProListPageData {}
